const tabSwitcherBox = Array.from(document.querySelectorAll('.tab-switcher__container'));
const tabSwitcherBoxData = tabSwitcherBox.map(el => (
  {
    container: el,
    tabSwitcherTabs: Array.from(el.querySelectorAll('.tab-switcher__tab ul li')),
    tabSwitcherTables: Array.from(el.querySelectorAll('.tab-switcher__table .table-item'))
  }
));

const hasTabSwitcher = () => {
  return tabSwitcherBox.length;
}

window.addEventListener('load', () => {
  if(hasTabSwitcher()) {
    tabSwitcherBoxData.forEach(tabSwitcherBox => {
      tabSwitcherInit(tabSwitcherBox)
    });
  }
});

const tabSwitcherInit = (tabSwitcherBoxData) => {
  tabSwitcherBoxData.tabSwitcherTabs[0].classList.add('current');
  tabSwitcherBoxData.tabSwitcherTables[0].classList.add('current');

  for(let i = 0; i < tabSwitcherBoxData.tabSwitcherTabs.length; i++) {
    tabSwitcherBoxData.tabSwitcherTabs[i].onmouseup = () => {
      getCurrent(i, tabSwitcherBoxData);
    }
  }
}

const getCurrent = (indexClicked, tabSwitcherBoxData) => {
  for(let n = 0; n < tabSwitcherBoxData.tabSwitcherTabs.length; n++) {
    indexClicked == n ?
      (tabSwitcherBoxData.tabSwitcherTabs[n].classList.add('current'), tabSwitcherBoxData.tabSwitcherTables[n].classList.add('current')) :
      (tabSwitcherBoxData.tabSwitcherTabs[n].classList.remove('current'), tabSwitcherBoxData.tabSwitcherTables[n].classList.remove('current'));
  }
}
